import { CarouselContext } from 'pure-react-carousel';
import { useContext, useEffect, useState } from 'react';

export const useCarouselState = () => {
  const carouselContext = useContext(CarouselContext);

  const [state, setState] = useState(carouselContext?.state);

  useEffect(() => {
    function onChange() {
      setState(carouselContext.state);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  return state;
};